import React, {Component} from 'react'
//import {TableComp} from 'sz-react-utils'
import _ from 'lodash'
import {Button, Drawer, Form, notification} from 'antd'
import Request from '../../../../request';
import {FormUtils as GetAllFormFields} from 'sz-react-utils'

import {connect} from 'react-redux'

@Form.create()

class ChangeBranch extends Component {
    state = {
        visible: true,
        arr: []


    }


    onOk = value => {
        this.reload()
    }
    reload = () => {
        this.table.current.reload()
    }

    constructor(props) {

        super(props)
        this.table = React.createRef()

    }

    componentDidMount() {
        const {studentName, studentBranchId} = this.props.param;
        this.loadSimpleBranch()

    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }


    loadSimpleBranch = async () => {
        this.setState({loading: true})
        let response = await Request.listSimpleBranch()
        if (response) {
            console.table(response.data)
            this.setState({arr: response.data})
        }
        this.setState({loading: false})
    }
    handleSubmit = e => {
        const {dispatch, form} = this.props;
        const {_id} = this.props.param;

        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let findIn = _.find(this.state.arr, (val) => {
                    return val._id == valData.studentBranchId;
                })
                let response = await Request.changeStudentBranch({
                    studentId: _id,
                    studentBranch: findIn ? findIn.id : null,
                    studentBranchId: valData.studentBranchId
                })
                notification.success({
                    message: 'Student Branch Changed Successfully.'
                })
                this.onClose()

            }
        })
    }


    render() {

        const {
            form: {getFieldDecorator, getFieldValue, setFieldsValue}
        } = this.props

        let {arr} = this.state;
        const {studentName, studentBranchId} = this.props.param;
        let inputTypes = {
            fields: [
                {
                    label: 'Choose New Branch',
                    key: 'studentBranchId',
                    type: 'select',

                    showSearch: true,
                    required: true,
                    allowClear: true,
                    width: 500,
                    keyAccessor: x => x._id,
                    valueAccessor: x => x.branchName,
                    options: arr,
                    placeholder: 'Select Branch',
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            studentBranchId: v
                        })
                    }
                }
            ]
        }
        return (
            <Drawer
                title={`Change Branch of Student :${studentName} `}
                // title={`Change Branch (${this.props.param.count})`}
                placement="right"
                closable={true}
                onClose={() => this.onClose()}
                visible={this.state.visible}
                width={1000}
                visible={true}
            >
                <div>
                    <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>

                        <div style={{padding: 20}}>
                            <h4>Student Branch Is {studentBranchId && studentBranchId.branchName}</h4>
                        </div>
                        <GetAllFormFields
                            inputSchema={inputTypes}
                            getFieldDecorator={getFieldDecorator}

                        />
                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{marginBottom: 10, marginLeft: '33%'}}
                            loading={this.props.loading}>
                            SAVE
                        </Button>
                    </Form>

                </div>
            </Drawer>

        )
    }
}

const mapStateToProps = ({global, router}) => ({
    categories: global.categories,
    search: router.location.search,
    currentUser: global.currentUser

})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ChangeBranch)
